export default __webpack_public_path__ + "static/media/roundTable.f69bb593.svg";